import React from "react";
import ResumeCard from "../Components/ResumeCard";
import Shadeddiv from "../Components/Shadeddiv";
import Skillsbar from "../Components/Skillsbar";
import Cvbtn from "../Components/Cvbtn";
import { skills } from "../Data";
import { myexperience } from "../Projects";
import { myeducation } from "../Projects";
const Resume = () => {
  return (
    <div
      className="bg-whatbg w-screen relative min-h-screen h-max flex flex-col  justify-evenly items-center gap-10"
      id="Resume"
    >
      {/* shaded div */}
      <Shadeddiv
        shadedtext={"Summary"}
        underlinetext1={""}
        underlinetext2={"Resume"}
        underlinetext3={""}
      />

      {/* cards container */}
      <div className="w-mywidth ml-56 px-8 flex flex-wrap gap-10 items-baseline justify-evenly mb-7 mt-6 lg:w-screen lg:ml-0 ">
        {/*education cards container */}
        <div className=" box-border flex flex-col w-[530px] items-center justify-between">
          <h4 className="text-white capitalize text-2xl text-center">
            my education
          </h4>
          {/* cards */}
          {myeducation.map((ele) => {
            const { year, title, institue, desc } = ele;
            return (
              <ResumeCard
                year={year}
                title={title}
                institue={institue}
                desc={desc}
              />
            );
          })}
        </div>

        {/* experience cards container */}
        <div className=" box-border flex flex-col w-[530px]">
          <h4 className="text-white capitalize text-2xl text-center">
            my experience
          </h4>
          {/* cards */}
          {myexperience.map((ele) => {
            const { year, title, institue, desc } = ele;
            return (
              <ResumeCard
                year={year}
                title={title}
                institue={institue}
                desc={desc}
              />
            );
          })}
        </div>
      </div>

      {/* skills bar */}
      <div
        className="ml-56 w-[1080px]  mb-10 lg:ml-0 lg:w-full
       gap-6 flex flex-col  justify-between items-center"
      >
        <h3 className="font-bold ml-4 text-white capitalize text-3xl">
          my skills
        </h3>
        <div className="flex justify-between items-center gap-6   flex-wrap p-2 w-full 2xl:flex-col  ">
          {skills.map((ele) => {
            const percentage = ele.percentage;
            const heading = ele.heading;
            const id = ele.id;
            const width = ele.width;
            return (
              <Skillsbar
                key={id}
                heading={heading}
                percentage={percentage}
                width={width}
              />
            );
          })}
        </div>
        {/* cv btn */}
        <Cvbtn value={false} />
      </div>
    </div>
  );
};

export default Resume;
